<template>
  <label
    class="mql-textradio"
    :class="[
      radioSize ? 'mql-textradio--' + radioSize : '',
      { 'is-disabled': isDisabled },
      { 'is-focus': focus },
      { 'is-defined': defined },
      { 'is-checked': !defined && model == label }
    ]"
    role="radio"
    :aria-checked="model == label"
    :aria-disabled="isDisabled"
    :tabindex="tabIndex"
    @keydown.space.stop.prevent="model = isDisabled ? model : label"
  >
    <span
      class="mql-textradio__input"
      :class="{
        'is-disabled': isDisabled,
        'is-checked': model == label
      }"
    >
      <template v-if="!defined">
        <input
          class="mql-textradio__original"
          :value="label"
          type="radio"
          aria-hidden="true"
          v-model="model"
          @focus="focus = true"
          @blur="focus = false"
          @change="handleChange"
          :name="name"
          :disabled="isDisabled"
          tabindex
        />
      </template>
    </span>
    <span class="mql-textradio__label" @keydown.stop>
      <slot :data="value"></slot>
      <template v-if="!$slots.default">{{label}}</template>
    </span>
  </label>
</template>
<script>
import Emitter from "element-ui/src/mixins/emitter";
export default {
  name: "MqlTextradio",
  mixins: [Emitter],
  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },
  componentName: "MqlTextradio",
  props: {
    value: {},
    label: {},
    disabled: Boolean,
    name: String,
    size: String,
    defined: Boolean
  },

  data() {
    return {
      focus: false
    };
  },
  computed: {
    isGroup() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== "MqlTextradioGroup") {
          parent = parent.$parent;
        } else {
          this.setRadioGroup(parent);
          return true;
        }
      }
      return false;
    },
    model: {
      get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set(val) {
        if (this.isGroup) {
          this.dispatch("MqlTextradioGroup", "input", [val]);
        } else {
          this.$emit("input", val);
        }
      }
    },
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize() {
      const temRadioSize =
        this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup
        ? this._radioGroup.textradioGroupSize || temRadioSize
        : temRadioSize;
    },
    isDisabled() {
      return this.isGroup
        ? this._radioGroup.disabled ||
            this.disabled ||
            (this.elForm || {}).disabled
        : this.disabled || (this.elForm || {}).disabled;
    },
    tabIndex() {
      return this.isDisabled || (this.isGroup && this.model !== this.label)
        ? -1
        : 0;
    }
  },

  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.$emit("change", this.model);
        this.isGroup &&
          this.dispatch("MqlTextradioGroup", "handleChange", this.model);
      });
    },
    setRadioGroup(parent) {
      this._radioGroup = parent;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1080px) {
  .mql-textradio {
    margin-right: 10px;
    padding: 6px 10px;
  }
}
.mql-textradio,
.mql-textradio__input {
  white-space: nowrap;
  line-height: 1;
  outline: 0;
}

.mql-textradio,
.mql-textradio__inner,
.mql-textradio__input {
  position: relative;
  display: inline-block;
}

.mql-textradio {
  margin-right: 10px;
  padding: 6px 18px;
  color: #606266;
  font-weight: 500;
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.mql-textradio.is-defined {
  padding: 0px 18px;
}

.mql-textradio.is-checked {
  background-color: rgba(153, 153, 153, 1);
}
.mql-textradio__input.is-disabled .mql-textradio__inner,
.mql-textradio__input.is-disabled.is-checked .mql-textradio__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

.mql-textradio__input {
  cursor: pointer;
  vertical-align: middle;
}

.mql-textradio__input.is-checked + mql-textradio__label {
  padding: 2px 18px;
  border-radius: 2px;
  background: #ededed;
}

.mql-textradio__input.is-disabled .mql-textradio__inner {
  cursor: not-allowed;
}

.mql-textradio__input.is-disabled .mql-textradio__inner::after {
  cursor: not-allowed;
  background-color: #f5f7fa;
}

.mql-textradio__input.is-disabled
  .mql-textradio__inner
  + .mql-textradio__label {
  cursor: not-allowed;
}

.mql-textradio__input.is-disabled.is-checked .mql-textradio__inner::after {
  background-color: #c0c4cc;
}

.mql-textradio__input.is-disabled + span.mql-textradio__label {
  color: #c0c4cc;
  cursor: not-allowed;
}

.mql-textradio__input.is-checked .mql-textradio__inner {
  border-color: #409eff;
  background: #409eff;
}

.mql-textradio__input.is-checked .mql-textradio__inner::after {
  -webkit-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}

.mql-textradio__input.is-focus .mql-textradio__inner {
  border-color: #409eff;
}

.mql-textradio__inner {
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.mql-textradio__inner:hover {
  border-color: #409eff;
}

.mql-textradio__inner::after {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #fff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) scale(0);
  transform: translate(-50%, -50%) scale(0);
  -webkit-transition: -webkit-transform 0.15s ease-in;
  transition: -webkit-transform 0.15s ease-in;
  transition: transform 0.15s ease-in;
  transition: transform 0.15s ease-in, -webkit-transform 0.15s ease-in;
}

.mql-textradio__original {
  opacity: 0;
  outline: 0;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

.mql-textradio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .mql-textradio__inner {
  -webkit-box-shadow: 0 0 2px 2px #409eff;
  box-shadow: 0 0 2px 2px #409eff;
}

.mql-textradio__label {
  font-size: 14px;
}

.mql-textradio__label .el-input {
  width: 100px;
  margin-right: 5px;
  margin-bottom: 0px;
}

.mql-textradio__label .el-input.el-input--medium .el-input__inner {
  height: 26px;
  line-height: 26px;
}
.mql-textradio__label .el-input.el-input--small .el-input__inner {
  height: 26px;
  line-height: 26px;
}

.mql-textradio .el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  line-height: 26px;
}

.mql-textradio .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 8px;
}

.mql-textradio .el-form-item__content .el-input {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlTextradio/index.vue